import React from "react";
import {
  PDFDownloadLink,
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Font,
  Image,
  PDFViewer,
} from "@react-pdf/renderer";
import logo from "../../assets/logo-avellaneda.png";
import RobotoBold from "../../fonts/roboto/Roboto-Bold.ttf";
import RobotoRegular from "../../fonts/roboto/Roboto-Regular.ttf";
import MenuItem from "@material-ui/core/MenuItem";

// Register font
Font.register({
  family: "RobotoBold",
  src: RobotoBold,
});
Font.register({
  family: "Roboto",
  src: RobotoRegular,
});

const colorPrincipal = "#83C442";

const styles = StyleSheet.create({
  page: { flexDirection: "column", padding: 25 },
  table: {
    fontSize: 10,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignContent: "stretch",
    flexWrap: "nowrap",
    alignItems: "stretch",
  },
  row: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    alignContent: "stretch",
    flexWrap: "nowrap",
    alignItems: "stretch",
    flexGrow: 0,
    flexShrink: 0,
    flexBasis: 50,
  },
  cell: {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: "auto",
    alignSelf: "stretch",
    textAlign: "center",
  },
  header: {
    backgroundColor: "#eee",
  },
  headerText: {
    fontSize: 11,
    fontWeight: 1200,
    color: "#1a245c",
    margin: 8,
  },
  tableText: {
    margin: 10,
    fontSize: 10,
  },
  franjaLogo: {
    backgroundColor: colorPrincipal,
    width: "100vw",
    paddingTop: 8,
    paddingBottom: 8,
  },
  image: {
    height: "20pt",
    width: "100pt",
    margin: "auto",
  },
});

const getTipoPadron = (tipoPadron) => {
  if (tipoPadron && tipoPadron.length > 0 && tipoPadron[0]) {
    return tipoPadron[0];
  }
  return "Error";
};

function MyDoc({ data }) {
  return (
    <Document>
      <Page style={{}} size="A4" orientation="landscape" wrap>
        <View style={[styles.franjaLogo]}>
          <Image src={logo} style={styles.image} />
        </View>
        <View style={[styles.table]}>
          <View style={[styles.row, styles.header]}>
            <Text style={[styles.headerText, styles.cell]}>Fecha y Hora</Text>
            <Text style={[styles.headerText, styles.cell]}>Nro Turno</Text>
            <Text style={[styles.headerText, styles.cell]}>Solicitante</Text>
            <Text style={[styles.headerText, styles.cell]}>DNI</Text>
            <Text style={[styles.headerText, styles.cell]}>Tipo Padrón</Text>
            <Text style={[styles.headerText, styles.cell]}>Padrón</Text>
            <Text style={[styles.headerText, styles.cell]}>Email</Text>
            <Text style={[styles.headerText, styles.cell]}>Tel. Fijo</Text>
            <Text style={[styles.headerText, styles.cell]}>Tel. Móvil</Text>
            <Text style={[styles.headerText, styles.cell]}>
              Cond. Suscriptor
            </Text>
            <Text style={[styles.headerText, styles.cell]}>Padrón Mult.</Text>
            <Text style={[styles.headerText, styles.cell]}>Asistencia</Text>
          </View>

          {data &&
            data.length > 0 &&
            data.map((row, index) => (
              <View
                key={index}
                style={[
                  styles.row,
                  {
                    borderBottom: "1px solid #ccc",
                    paddingTop: "8pt",
                  },
                ]}
              >
                <Text style={[styles.cell]}>{row.fechaHora}</Text>
                <Text style={[styles.cell]}>{row.id}</Text>
                <Text style={[styles.cell]}>{row.solicitante}</Text>
                <Text style={[styles.cell]}>{row.dni}</Text>
                <Text style={[styles.cell]}>
                  {getTipoPadron(row.tipoPadron)}
                </Text>
                <Text style={[styles.cell]}>{row.padron}</Text>
                <Text style={[styles.cell]}>{row.email}</Text>
                <Text style={[styles.cell]}>{row.telFijo}</Text>
                <Text style={[styles.cell]}>{row.telMovil}</Text>
                <Text style={[styles.cell]}>{row.condicionSuscriptor}</Text>
                <Text style={[styles.cell]}>
                  {row.padronMultiple ? "SI" : "NO"}
                </Text>
                <Text style={[styles.cell]}>
                  {row.asistio ? "Asistió" : "Pendiente"}
                </Text>
              </View>
            ))}
        </View>
      </Page>
    </Document>
  );
}

// function TurnoPdf({ nombreArchivo, data }) {
//     const dataDemo = [
//         {
//             id: 1,
//             solicitante: "Nombre",
//             dni: "33444333",
//             fechaHora: "12/7/2021",
//             tipoPadron: "K - KIOSCOS/PUESTOS COLOCADOS EN LA VIA PUBLICA",
//             padron: "abc123",
//             asistio: true,
//         },
//         {
//             id: 1,
//             solicitante: "Nombre",
//             dni: "33444333",
//             fechaHora: "12/7/2021",
//             tipoPadron: "K - KIOSCOS/PUESTOS COLOCADOS EN LA VIA PUBLICA",
//             padron: "abc123",
//             asistio: true,
//         },
//         {
//             id: 1,
//             solicitante: "Nombre",
//             dni: "33444333",
//             fechaHora: "12/7/2021",
//             tipoPadron: "K - KIOSCOS/PUESTOS COLOCADOS EN LA VIA PUBLICA",
//             padron: "abc123",
//             asistio: true,
//         },
//         {
//             id: 1,
//             solicitante: "Nombre",
//             dni: "33444333",
//             fechaHora: "12/7/2021",
//             tipoPadron: "K - KIOSCOS/PUESTOS COLOCADOS EN LA VIA PUBLICA",
//             padron: "abc123",
//             asistio: true,
//         },
//     ];

//     return (
//         <div>
//             <PDFViewer style={{ width: "100%", height: "100vh" }}>
//                 <MyDoc data={dataDemo} />
//             </PDFViewer>
//         </div>
//     );
// }

function TurnoPdf({ nombreArchivo, data, textoBtnPdf }) {
  return (
    <div>
      <PDFDownloadLink
        document={<MyDoc data={data} />}
        fileName={nombreArchivo}
      >
        {({ blob, url, loading, error }) =>
          loading ? "Cargando..." : textoBtnPdf
        }
      </PDFDownloadLink>
    </div>
  );
}

export default TurnoPdf;
